import React, { useMemo, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Input, Row, Icon } from "antd";

import AddressesModal from "../addresses-modal/addresses-modal";
import SelectedAddresses from "../selected-addresses/selected-addresses";
import useAddressesFields from "../../../hooks/useAddressesFields";
import { controlModal } from "../../../store/actions/voting.actions";
import selectedAddressesToTree from "../../../utils/selectedAddressesToTree";

import "./addresses-field.scss";

const AddressesField = memo(({ addresses: selectedAddressesArray, form }) => {
	const { getFieldDecorator, setFieldsValue } = form;
	const dispatch = useDispatch();
	const addressesTree = useSelector(
		(store) => store.votingStore.addresses.addresses
	);
	const selectedAddresses = useMemo(() => {
		return selectedAddressesToTree(selectedAddressesArray, addressesTree);
	}, [selectedAddressesArray, addressesTree]);

	useAddressesFields(getFieldDecorator);

	return (
		<>
			{selectedAddresses.length === 0 && (
				<div
					className="addresses-field"
					onClick={(e) => {
						e.preventDefault();
						dispatch(controlModal(true, "root", addressesTree));
					}}
				>
					<Row gutter={8}>
						<Col span={24}>
							<Form.Item label="Адреса">
								<Input
									className="input"
									placeholder="Выбрать адреса"
									suffix={<Icon type="profile" className="icon" />}
								/>
							</Form.Item>
						</Col>
					</Row>
				</div>
			)}
			{selectedAddresses.length !== 0 && (
				<SelectedAddresses
					selectedAddresses={selectedAddresses}
					setFieldsValue={setFieldsValue}
				/>
			)}
			<AddressesModal
				onOk={() => {
					dispatch(controlModal(false, "", []));
				}}
				onCancel={() => dispatch(controlModal(false, "", []))}
				form={form}
			/>
		</>
	);
});

export default AddressesField;
